import React from "react";
import { Mono } from "../primitives/typography";

function dayLabel(iso: string): string {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";

    const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const today = startOfDay(new Date());
    const diffDays = Math.round((today - startOfDay(date)) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    if (diffDays > 1 && diffDays < 7) return date.toLocaleDateString([], { weekday: "long" });
    return date.toLocaleDateString([], { month: "long", day: "numeric", year: "numeric" });
}

/** Returns true when `current` falls on a different calendar day than `previous`. */
function isNewDay(current: string, previous: string | undefined): boolean {
    if (!previous) return true;
    const a = new Date(current);
    const b = new Date(previous);
    return a.toDateString() !== b.toDateString();
}

interface ChatDateDividerProps {
    iso: string;
}

const ChatDateDivider: React.FC<ChatDateDividerProps> = ({ iso }) => {
    return (
        <div className="flex items-center justify-center py-2">
            <Mono className="bg-muted text-muted-foreground rounded-full px-3 py-1 text-[11px]">{dayLabel(iso)}</Mono>
        </div>
    );
};

export { ChatDateDivider, dayLabel, isNewDay };
